import $axios from "@/helpers/axios-helper";
import { service_paths } from "@/constants/Services";
import { getId } from "@/helpers/utils";
import { API_RESPONDENT, PARAMS_API } from "./index.js";
import { mapGetters } from "vuex";

const dataOts = {
  data() {
    return {
      optionSelected: {
        classList: [],
        termList: [],
        gradeList: [],
        programList: [],
        studentList: [],
        parentList: [],
        teacherList: [],
        roleList: []
      }
    };
  },
  computed: {
    ...mapGetters("user", {
      info: "info"
    })
  },
  methods: {
    debounceSearchKey: async function(event, params, url) {
      const responseData = await $axios.get(
        `${url}`,
        params,
        undefined,
        undefined,
        undefined,
        undefined,
        false
      );
      if (this.resSetting === "other_staffs") {
        this.fetchRoleOpts(responseData);
      }
      eval(API_RESPONDENT[this.respondentFilter.filter]);
    },
    fetchDebounceSurvey: async function(event, params, url) {
      const responseData = await $axios.get(
        `${url}`,
        params,
        undefined,
        undefined,
        undefined,
        undefined,
        false
      );
      if (this.resSetting === "other_staffs") {
        this.fetchRoleOpts(responseData);
      }
      eval(API_RESPONDENT[this.respondentFilter.filter]);
    },
    getOptionList: async function(typeList, data, displayField) {
      if (this.isSettingEdit) {
        this.optionSelected[typeList] = this.formatOption(
          displayField,
          this.optionSelected[typeList]
        );
      }
      let optionList = data.filter(type => {
        return !this.optionSelected[typeList]
          .map(item => getId(item))
          .includes(getId(type));
      });
      optionList = this.formatOption(displayField, optionList);
      this.optionResSelected = [
        ...this.optionSelected[typeList],
        ...optionList
      ];
    },
    formatOption(displayField, arr) {
      let displayName = [];
      const arrFormat = arr.map(type => {
        if (displayField) {
          displayName = displayField.map(field => {
            return `${type[field]}`;
          });
        }
        return {
          id: getId(type),
          name:
            type.name || displayName.filter(item => item !== "null").join(" - ")
        };
      });
      return arrFormat;
    },
    fetchClassOpts: async function(responseData) {
      const response = await responseData;
      if (response.data.data.length) {
        this.getOptionList("classList", response.data.data);
      }
    },
    fetchTermOpts: async function(responseData) {
      const response = await responseData;
      if (response.data.data.length) {
        this.getOptionList("termList", response.data.data);
      }
    },
    fetchGradeOpts: async function(responseData) {
      const response = await responseData;
      this.getOptionList("gradeList", response.data.data);
    },
    fetchProgramOpts: async function(responseData) {
      const response = await responseData;
      if (response.data.data.length) {
        this.getOptionList("programList", response.data.data);
      }
    },
    fetchStudentOpts: async function(responseData) {
      const response = await responseData;
      if (response.data.data.length) {
        this.getOptionList("studentList", response.data.data, [
          "full_name",
          "student_code"
        ]);
      }
    },
    fetchFamilyOpts: async function(responseData) {
      const response = await responseData;
      if (response.data.data.length) {
        this.getOptionList("parentList", response.data.data, [
          "full_name",
          "username"
        ]);
      }
    },
    fetchTeacherOpts: async function(responseData) {
      const response = await responseData;
      if (response.data.data.length) {
        this.getOptionList("teacherList", response.data.data, [
          "full_name",
          "staff_code"
        ]);
      }
    },
    fetchRoleOpts: async function(responseData) {
      const response = await responseData;
      if (response.data.length) {
        const formatResponse = response.data.filter(
          role => role.name !== "Teacher"
        );
        this.getOptionList("roleList", formatResponse);
      }
    },
    async fetchSurvey(event) {
      if (this.respondentFilter.filter !== "all") {
        const paramsType = PARAMS_API(event)[this.respondentFilter.filter];
        if (this.isRoleTeacher) {
          paramsType.url = `${service_paths.users}/${getId(this.info)}/classes`;
        }
        await this.debounceSearchKey(
          paramsType.event,
          paramsType.params,
          paramsType.url
        );
      }
    }
  }
};

export { dataOts };
